/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsPerDocumentTypeDto } from '../../models/submissions-per-document-type-dto';

export interface DashboardSubmissionsPerDocumentTypeGet$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardSubmissionsPerDocumentTypeGet(http: HttpClient, rootUrl: string, params?: DashboardSubmissionsPerDocumentTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDocumentTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardSubmissionsPerDocumentTypeGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsPerDocumentTypeDto>>;
    })
  );
}

dashboardSubmissionsPerDocumentTypeGet.PATH = '/Dashboard/submissions-per-document-type';
